export default {"src":"/wp-content/themes/GKH-Theme/bamistarim/_next/static/media/logo-black.df0ad8d9.svg","height":107,"width":48};